import { Card } from 'primereact/card';
import placeHolder from '../../../src/assets/images/PlaceHolder.webp';
import { InputText } from 'primereact/inputtext';
import { useState, useEffect } from 'react';
import { useCatchResponse } from '../../utils/useCatchResponse';
import APIConstant from "../../utils/pathConstants";
import Loader from '../Shared/Loader/Loader';
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { apiBase } from '../../utils/config';
import Header from '../Header/Header';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';


const ChildrenList = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    // const [securityUserID, setSecurityUserID] = useState("");
    const [childreenList, setChildreenList] = useState([]);
    const [financialYears, setFinancialYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');


    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        // setSecurityUserID(loginData?._id);
        getFinancialYear(loginData?.UserRole === 'Parent' ? loginData?.CreatedBy : loginData?._id);
        GetChildreenList(loginData?._id);
    }, []);

    const getFinancialYear = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (res?.data) {
                        const filterData = res?.data?.flatMap(y =>
                            y?.CalendarValue?.map(x => ({
                                label: `${moment(x?.StartDate).format("YYYY")}-${moment(x?.EndDate).format("YYYY")}`,
                                value: x?._id
                            }))
                        );
                        setFinancialYears(filterData);
                    }
                } else {
                    console.log("Error in else get Financial Year: ", res);
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (error) {
            console.log("Error get Financial Year: ", error);
            catchResponse(error);
        }
    }

    const GetChildreenList = async (id) => {
        try {
            let data = {
                UserID: id
            }
            await api.post(APIConstant.path.getChildreenDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setChildreenList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                // catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const filteredData = childreenList?.filter((child) =>
        Object.values(child)
            .join(' ')
            .toLowerCase()
            .includes(globalFilterValue.toLowerCase())
    );

    const handleCardClick = async (id) => {
        const loginData = CommonConfig.loginData();
        CommonConfig.setCookie('selected_childId', id);
        await CommonConfig.getUserMenu(loginData, navigate, 'OnClick');
    }

     const handleYearChange = (e) => {
            setSelectedYear(e.value);
        };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user"></i>
                    <h2>Childreen List</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Header isExpanded={true} />
                </div>
            </div>
            <div className="p-grid">
                {filteredData?.map((child, index) => (
                    <div key={index}>
                        <Card title={child?.Name} className="shadow-3 mb-4" onClick={() => handleCardClick(child?.id)}>
                            <div className="flex align-items-center gap-2">
                                <img
                                    src={child?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${child?.ProfilePhotoUrl}` : placeHolder}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = placeHolder;
                                    }}
                                    style={{ width: '200px', height: '150px', borderRadius: '50%', objectFit: 'cover' }}
                                />
                            </div>
                            <p><strong>Class:</strong> {child?.ClassName}</p>
                            <p><strong>Roll No:</strong> {child?.RollNo}</p>
                            <Dropdown
                                className="p-w-100 p-mt-1"
                                name='selectedYear'
                                inputId='selectedYear'
                                value={selectedYear}
                                options={financialYears}
                                onChange={handleYearChange}
                                placeholder="Select Academic Year"
                                filter
                                onClick={(e) => e.stopPropagation()}
                            />
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChildrenList;
